if (!customElements.get('gc-newsletter-popup')) {
  class GcNewsletterPopup extends HTMLElement {
    constructor() {
      super();
      this.storageKey = 'gcNewsletterPopupDismissed';
      this.dialog = this.querySelector('dialog');
      this.closeButton = this.querySelector('.gc-popup__close');
      this.form = this.querySelector('form');
    }

    connectedCallback() {
      if (!this.dialog) return;

      const showOnce = this.dataset.showOnce === 'true';
      const alreadyDismissed = showOnce && this.getDismissed();
      const justSubmitted = this.querySelector('.newsletter-form__message--success');
      const hasErrors = this.querySelector('.newsletter-form__message.form__message:not(.newsletter-form__message--success)');

      if (justSubmitted) {
        this.setDismissed();
        this.open();
        this.bindClose();
        return;
      }

      if (hasErrors) {
        this.open();
        this.bindClose();
        return;
      }

      if (alreadyDismissed) return;

      const delay = parseInt(this.dataset.delay, 10) || 6000;
      this.timer = window.setTimeout(() => {
        this.open();
      }, delay);

      this.bindClose();

      if (this.form) {
        this.form.addEventListener('submit', () => {
          this.setDismissed();
        });
      }
    }

    open() {
      if (this.dialog.open) return;
      try {
        this.dialog.showModal();
      } catch (e) {
        this.dialog.setAttribute('open', '');
      }
    }

    close() {
      this.setDismissed();
      if (typeof this.dialog.close === 'function') {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
      }
    }

    bindClose() {
      if (this.closeButton) {
        this.closeButton.addEventListener('click', () => this.close());
      }
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.dialog.addEventListener('cancel', () => {
        this.setDismissed();
      });
    }

    getDismissed() {
      try {
        return window.localStorage.getItem(this.storageKey) === 'true';
      } catch (e) {
        return false;
      }
    }

    setDismissed() {
      try {
        window.localStorage.setItem(this.storageKey, 'true');
      } catch (e) {
        /* localStorage unavailable, no-op */
      }
    }
  }

  customElements.define('gc-newsletter-popup', GcNewsletterPopup);
}
